import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Option, Select } from "uikit";

import Chart from "../Content/Chart";

interface Props {
	value: Chart.ChartType;
	onChange: (value: Chart.ChartType) => void;
}

const OPTIONS: Option<Chart.ChartType>[] = [
	{
		key: "linear",
		label: "mainPage.reports.charts.type.linear",
		value: "linear",
	},
	{
		key: "columnar",
		label: "mainPage.reports.charts.type.columnar",
		value: "columnar",
	},
	{
		key: "circular",
		label: "mainPage.reports.charts.type.circular",
		value: "circular",
	},
];

const ChartTypeSelect: React.FC<Props> = ({ value, onChange }) => {
	const { t } = useTranslation();

	const options = useMemo<Option<Chart.ChartType>[]>(
		() =>
			OPTIONS.map((option) => ({
				...option,
				label: t(option.label) || option.label,
			})),
		[t],
	);

	return (
		<Select<Chart.ChartType>
			value={value}
			onChange={(key) => {
				onChange(key as Chart.ChartType);
			}}
			options={options}
		/>
	);
};

export default ChartTypeSelect;
